module.exports = __webpack_public_path__ + "static/daigoji-map-eae90325d92e27002555a874f87d6de4.jpg";